<tt-page *ngIf="['tablet', 'mobile'] | mediaQuery">
    <ng-container *ngTemplateOutlet="filters"></ng-container>
    <tt-list class="height-full" ttHeightFull [ttData]="purchHeads" ttBadge="badgeinfo"></tt-list>
</tt-page>

<tt-side-drawer-container>
    <tt-divider *ngIf="!(['tablet', 'mobile'] | mediaQuery)" ttRememberId="purchheads.dividers">
        <tt-divider-rows>
            <tt-divider-pane ttSize="50">
                <tt-divider-columns>
                    <tt-divider-pane ttSize="30">
                        <ng-container *ngTemplateOutlet="filters"></ng-container>
                    </tt-divider-pane>
                    <tt-divider-pane ttSize="70">
                        <tt-grid *ngIf="!!grid" [(ttOptions)]="grid" ttRowSelection (ttOnRowSelected)="onPurchHeadSelected($event)"></tt-grid>
                    </tt-divider-pane>
                </tt-divider-columns>
            </tt-divider-pane>
            <tt-divider-pane ttSize="50">
                <tt-purch-head-purch-lines (gridReady)="gridPurchLines = $event"></tt-purch-head-purch-lines>
            </tt-divider-pane>
        </tt-divider-rows>
    </tt-divider>

    <ng-container>
        <tt-button *ngIf="purchHead.currentPurchHead$ | async" class="drawer-toggle" ttText="purchhead" (ttClick)="drawer.toggle()"></tt-button>
        <tt-side-drawer #drawer ttRememberId="w_purchheads.purchheaddrawer" ttPersistLocalOnly="false" ttInitialState="close" ttDisableClose ttPosition="end" ttWidth="30rem" ttMode="side">
            <tt-tabs #tabs>
                <tt-tab ttId="PURCHHEAD" ttLabel="purchhead_gb_main_purchhead" ttIcon="far fa-info-circle"></tt-tab>

                <tt-tab ttId="FUNCTIONS" ttLabel="purchhead_functions" ttIcon="far fa-ellipsis-h"></tt-tab>
            </tt-tabs>
            <tt-purch-head-head [hidden]="tabs.ttSelectedId !== 'PURCHHEAD'" (linesChanged)="gridPurchLines?.gridfunc?.read()"></tt-purch-head-head>
            <tt-purch-head-functions [hidden]="tabs.ttSelectedId !== 'FUNCTIONS'" (onDelete)="onHeadDelete()"></tt-purch-head-functions>
        </tt-side-drawer>
    </ng-container>
</tt-side-drawer-container>

<ng-template #filters>
    <tt-card *ngIf="!!get">
        <tt-select ttLabel="businessco" [(ttModel)]="get.businessco_no" (ttModelChange)="searchPurchases()" [ttData]="companies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
        <form (submit)="searchPurchases()">
            <tt-input [ttRememberId]="this.get.webpage + '.searchtext'" ttLabel="searchtext" [(ttModel)]="get.searchtext" (ttModelChange)="onSearchTextChanged($event)" ttShowClearButton>
                <ng-container buttons>
                    <tt-form-field-button ttId="search" ttIcon="fas fa-search" (ttClick)="searchPurchases()"></tt-form-field-button>
                </ng-container>
            </tt-input>
        </form>
        <tt-search
            *ngIf="get.argtype === '-' && get.argvalue === '-'"
            ttLabel="searchtext_supplier"
            [(ttModel)]="get.searchtext_supplier"
            tt-change="vm.onChangedSearchTextSupplier($value, $item)"
            [ttSearch]="supplierSearch"
            (ttOnSelected)="onSupplierSelected($event)"
            (ttOnClear)="onSupplierSelected()"
        ></tt-search>
        <tt-input [hidden]="!(get.supplier_no > '0' && get.searchtext_supplier > '')" ttLabel="supplier_no" [ttModel]="get.supplier_no" ttReadonly></tt-input>
        <tt-select ttLabel="reg_by_user" [(ttModel)]="get.portal_user_keyno" (ttModelChange)="searchPurchases()" [ttData]="portalUsers" ttShowClearButton tt-buttons="vm.model.portalUsersButtons">
            <ng-container buttons>
                <tt-form-field-button
                    ttId="setcurrent"
                    ttIcon="fas fa-user"
                    ttType="success"
                    (ttClick)="get.portal_user_keyno = get.current_portal_user_keyno; searchPurchases()"
                ></tt-form-field-button>
            </ng-container>
        </tt-select>
        <tt-select
            ttLabel="purchasestatus"
            [(ttModel)]="get.purchasestatus_id"
            (ttModelChange)="searchPurchases()"
            [ttData]="purchaseStatuses"
            ttDataId="purchasestatus_id"
            ttDataName="purchasestatus_name"
            ttShowClearButton
            ttClearValue="999"
        ></tt-select>

        <tt-input [hidden]="!get.supplier_no_and_name" ttLabel="supplier_no_and_name" [ttModel]="get.supplier_no_and_name" ttReadonly></tt-input>

        <tt-button-goto ttText="purchheads_create" ttIcon="fa fa-solid fa-plus" ttGoto="purchheadcreate" [ttGotoParms]="{ argtype: get.argtype, argvalue: get.argvalue }"></tt-button-goto>
    </tt-card>
</ng-template>
